/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo/Marca.webp';
import { AuthContext } from '../../context/Auth/AuthContext';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import * as S from '../../styles/Login/Login-styles';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const Login = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
    clearLoading,
    setClearLoading,
  }: any = useContext(LoadingContext);

  useEffect(() => {
    let path = window.location.pathname.split('/')[2];
    const pathOne = window.location.pathname.split('/')[1];
    const p = JSON.parse(sessionStorage.getItem('user'));
    path === undefined ? (path = '') : (path = path);
    if (p) {
      p.permissions.includes('Admin')
        ? pathOne === '/' || pathOne === ''
          ? navigate('/admin/' + path)
          : navigate('/' + pathOne + '/' + path)
        : navigate('/vendedor/' + path);
    }
  });

  const handleLogin = async (e) => {
    e.preventDefault();

    if (username && password) {
      setLoading(true);
      try {
        const isLogged = await auth.signin(username, password);
        if (isLogged) {
          setClearLoading();
          //Preferência de logar sempre na área admin
          const p = JSON.parse(sessionStorage.getItem('user'));
          p.permissions.includes('Admin') ? navigate('/admin/orcamento') : navigate('/vendedor');
        }
      } catch (e) {
        let msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      }
    }
  };

  return (
    <S.Container>
      <S.ContainerLogin>
        <S.WrapLogin>
          <S.LoginForm>
            <S.LoginFormTitle>
              <img src={logo} className="login-logo" alt="logo" />
            </S.LoginFormTitle>
            <S.LoginInput>
              <S.InputLogin
                className="input-login"
                value={username}
                onChange={(e) => setUser(e.target.value)}
                type="text"
                placeholder="Usuário"
              />
            </S.LoginInput>
            <S.LoginInput>
              <S.InputLogin
                className="input-login"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? 'text' : 'password'} // Alterar o tipo do input para mostrar/ocultar a senha
                placeholder="Senha"
              />

              <S.PassIcon onClick={() => setShowPassword((prevShowPassword) => !prevShowPassword)}>
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </S.PassIcon>
            </S.LoginInput>
            <S.ContainerLoginFormBtn>
              <S.LoginBtn onClick={handleLogin}>Entrar</S.LoginBtn>
            </S.ContainerLoginFormBtn>
          </S.LoginForm>
        </S.WrapLogin>
      </S.ContainerLogin>
    </S.Container>
  );
};

export default Login;
